import { toast } from "sonner";

export const CURRENCIES = ["CNY", "JPY", "KRW", "USD", "EUR", "AUD", "IDR"];
export const inp = "w-full min-w-0 border border-mist rounded-sm px-3 py-2 bg-white text-ink normal-case tracking-normal text-base md:text-sm focus:outline-none focus:border-sage-dark";
export const btn = "inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-sm text-xs uppercase tracking-widest disabled:opacity-50 transition-colors";
export const btnPrimary = `${btn} bg-sage-dark text-white hover:bg-sage-deep`;
export const btnGhost = `${btn} border border-mist bg-white text-ink hover:border-sage-dark`;
export const fmtIDR = (n) => (n == null || Number.isNaN(Number(n)) ? "—" : `Rp${Math.round(Number(n)).toLocaleString("id-ID")}`);
export const fmtNum = (n) => (n == null || n === "" || Number.isNaN(Number(n)) ? "—" : Number(n).toLocaleString("en-US", { maximumFractionDigits: 4 }));
export const toNum = (s) => {
    if (s === "" || s == null) return null;
    const n = Number(String(s).replace(/,/g, ""));
    return Number.isFinite(n) ? n : null;
};
export const errMsg = (e, fallback = "Failed") => {
    const d = e?.response?.data?.detail;
    if (Array.isArray(d)) return d[0]?.msg || fallback;
    if (d && typeof d === "object") return d.message || fallback;
    return d || fallback;
};
export const toastErr = (e, fallback) => toast.error(errMsg(e, fallback));
export const fmtCur = (cur, n) => (n == null || n === "" || Number.isNaN(Number(n)) ? "—" : cur === "CNY" ? `¥${fmtNum(n)}` : `${cur} ${fmtNum(n)}`);

const COLS = ["Invoice Date", "Supplier", "Supplier SKU", "Jubelio/Hoshizora SKU", "Product Name", "Qty", "Currency", "Unit Price", "Exchange Rate", "Base Cost IDR", "Line Amount"];
const cell = (v) => String(v ?? "").replace(/[\t\r\n]+/g, " ");

export function invoiceTSV(inv) {
    const rows = (inv.items || []).map((i) => [inv.invoice_date, inv.supplier_name, i.supplier_sku, i.jubelio?.item_code || "", i.jubelio?.name || i.description || "",
        i.qty, inv.currency, i.unit_price, inv.exchange_rate, i.base_cost_idr, i.line_amount]);
    return [COLS, ...rows].map((r) => r.map(cell).join("\t")).join("\n");
}

export async function copyText(text) {
    try {
        await navigator.clipboard.writeText(text);
    } catch {
        const ta = document.createElement("textarea");
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
    }
}
